/*
* @Author: abhishek714
* @Date:   2025-03-12 11:33:37
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-24 12:57:53
*/
import React from 'react';
import UserService from './../../services/UserService/UserService';
import SideBar from '../../components/User/SideBar';
import GearSpinner from './../../components/GearSpinner/GearSpinner';
import Loader from './../../components/Loader/Loader';
import uploadImageIcon from '../../images/assets/image-plus.webp';
import teamUserIcon from '../../images/team-user-img.png';
import teamMailIcon from '../../images/team-mail-img.png';
import teamPhoneIcon from '../../images/team-phone-img.png';
import teamCheckIcon from '../../images/team-check-icon.png';
import teamDeleteIcon from '../../images/team-delete-img.png';
import { SITE_URL, urlPath, ucwords } from '../../constants.js';
import { Validation } from '../../validation';

class TeamDetails extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			fields: {
				"is_show_net_pricing" : 0,
				"is_show_open_order" : 0,
				"is_show_order_history" : 0
			},
			errors: {},
			userData: {},
			user_roles: {
				"admin" : "Admin",
				"associate" : "Associate", 
			},
			team_members: {},
			page:"",
			form_success_message:"",
			form_error_message:"",
			isSpin:0,
			isLoading:0,
			deleteMemberId:0,
			isShowConfirmationModal:0,
			isShowMessageModal:0,
			success_message:"",
			error_message:""
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleRoleChange = this.handleRoleChange.bind(this);
		this.setAccess = this.setAccess.bind(this);
		this.setTeamAccess = this.setTeamAccess.bind(this);
		this.handleInvite = this.handleInvite.bind(this);
		this.sendInvitation = this.sendInvitation.bind(this);
		this.reSendInvitation = this.reSendInvitation.bind(this);
		this.updateMemberData = this.updateMemberData.bind(this);
		this.userService = new UserService();
	}

	componentDidMount() {
		this.setState((prevState) => ({
	        userData: {
	          ...prevState.userData, // Preserve existing userData properties
	          user_id: localStorage.getItem('techtop_user_id'),
	          first_name: localStorage.getItem('techtop_user_first_name'),
	          last_name: localStorage.getItem('techtop_user_last_name'),
	          company: localStorage.getItem('techtop_user_company'),
	          company_logo: (localStorage.getItem('techtop_user_company_logo') !== 'null' && localStorage.getItem('techtop_user_company_logo') !== null && localStorage.getItem('techtop_user_company_logo') !== '') ? SITE_URL + "files/company_logo/" + localStorage.getItem('techtop_user_company_logo') : uploadImageIcon,
	          is_logo: (localStorage.getItem('techtop_user_company_logo') !== 'null' && localStorage.getItem('techtop_user_company_logo') !== null && localStorage.getItem('techtop_user_company_logo') !== '') ? true : false,
	          cell_phone: localStorage.getItem('techtop_user_cell_phone'),
	          direct_phone: localStorage.getItem('techtop_user_direct_phone'),
	          fax: localStorage.getItem('techtop_user_fax'),
	          address: localStorage.getItem('techtop_user_address'),
	          state: localStorage.getItem('techtop_user_state'),
	          city: localStorage.getItem('techtop_user_city'),
	          zip: localStorage.getItem('techtop_user_zip'),
	          email: localStorage.getItem('techtop_user_email'),
	          phone: localStorage.getItem('techtop_user_phone'),
	          user_role: localStorage.getItem("techtop_user_user_role")
	        }
	    }));
		this.setState({ page : urlPath.replace("user/","")});
		this.getTeamMembers(localStorage.getItem('techtop_user_id'));
	}

	getTeamMembers(user_id) {
		this.setState({ isSpin : 1 });
		this.userService.getTeamMembers(user_id).then(response => {
			this.setState({ isSpin : 0 });
			if(response.data.response === 'success') {
				this.setState({ team_members : response.data.result });
			}
		})
	}

	setAccess(access) {
		this.setState(prevState => ({
	        fields: {
	            ...prevState.fields,
	            [access]: prevState.fields[access] === '1' ? '0' : '1' // Toggle between '1' and '0'
	        }
	    }));
	}

	setTeamAccess(access, memberId) {
		let { team_members } = this.state;
		const updatedTeamMembers = team_members.map(member =>
	        Number(member.id) === Number(memberId)
	            ? { ...member, [access]: member[access] === 1 ? 0 : 1 }
	            : member
	    );
	    const memberData = updatedTeamMembers.filter(member => Number(member.id) === Number(memberId))

	    const data = {"fields": {"field_name" : `${access}`, "field_value" : memberData[0][access]}, "user_id" : memberId};
	    this.updateMemberData(data);
	    this.setState({ team_members: updatedTeamMembers });
	}

	handleChange(field, e){
		let { fields, errors } = this.state; 
		const { name, value } = e.target;
		const newFormData = {
            ...fields,
            [name]: value,
        };
        errors = {
        	...errors,
        	[name]:''
        };
        this.setState({fields : newFormData, errors : errors, form_error_message : '', form_success_message: '' });
	}

	handleRoleChange(memberId,e) {
		let { team_members } = this.state;
		const { name, value } = e.target;
		const updatedTeamMembers = team_members.map(member =>
	        Number(member.id) === Number(memberId)
	            ? { ...member, "user_role": value }
	            : member
	    );
	    const memberData = updatedTeamMembers.filter(member => Number(member.id) === Number(memberId))
	    const data = {"fields": {"field_name" : "user_role", "field_value" : memberData[0]["user_role"]}, "user_id" : memberId};
	    this.updateMemberData(data);
	    this.setState({ team_members: updatedTeamMembers });
	}

	handleInvite(e) {
	    e.preventDefault();
	    const { fields } = this.state;
	    let validationFields = ['first_name', 'last_name', 'email', 'user_role'];

	    let errors = Validation(fields, validationFields);
	    if (Object.keys(errors).length > 0) {
	        this.setState({ errors: errors });
	        return;
	    }
	    this.sendInvitation(e);
	}

	sendInvitation() {
		const { fields, errors, userData } = this.state;
		this.setState({ isLoading : 1});
		fields['associate_with'] = userData.user_id
		fields['is_admin'] = 0
		this.userService.inviteUser(fields).then(response => {
			this.setState({ isLoading : 0});
			if(response.status===200) {
				if(response.data.response==='fail') {
        			this.setState({form_error_message:response.data.message});
        		} else {
        			this.getTeamMembers(localStorage.getItem('techtop_user_id'));
        			this.setState({form_success_message:response.data.message, fields : {}});
        		}
			}
		})
	}

	reSendInvitation(e,memberId) {
		e.preventDefault();
		this.setState({ isLoading : 1});
		this.userService.resendInvite({ user_id : memberId}).then(response => {
			this.setState({ isLoading : 0});
			if(response.status===200) {
				if(response.data.response==='fail') {
        			this.setState({form_error_message:response.data.message});
        		} else {
        			this.getTeamMembers(localStorage.getItem('techtop_user_id'));
        			this.setState({form_success_message:response.data.message, fields : {}});
        		}
			}
		})
	}

	handleRemoveUser(e) {
		e.preventDefault()
		const { deleteMemberId } = this.state;
		if(deleteMemberId !== 0) {
			this.setState({ isShowConfirmationModal:!this.state.isShowConfirmationModal });
			this.setState({ isShowMessageModal: !this.state.isShowMessageModal });
			this.userService.removeUser({user_id:deleteMemberId}).then(response => {
				const result = response.data;
				if(result.response === 'success') {
					this.setState({success_message: result.message});
				} else {
					this.setState({error_message: result.message});
				}
				this.getTeamMembers(localStorage.getItem('techtop_user_id'));
			})
		}
		setTimeout(() => {
    		this.setState({ isShowMessageModal:!this.state.isShowMessageModal ,isShowMessageModal: !this.state.isShowMessageModal, deleteMemberId : 0 ,success_message : '', error_message: '' });
    	},2000);
	}

	updateMemberData(data) {
		this.setState({isLoading : true });
		this.userService.updateMemberData(data).then(response => {
			this.setState({isLoading : false });
			const result = response.data;
			console.log(result);
		})
		this.getTeamMembers(localStorage.getItem('techtop_user_id'));
	}

	renderConfirmationModal() {
		let { isShowConfirmationModal } = this.state;
		if(isShowConfirmationModal) {
			return(
				<React.Fragment>
					<div className="motor-modal-overlay">
						<div className="motor-modal-content">
							<h6>Do you really want to remove this user?</h6>
							<div className="d-flex w-100 justify-content-evenly gap-4">
								<button type="button" className="btn btn-secondary w-50 m-0 rounded" onClick={(e) => this.setState({ isShowConfirmationModal : 0 })}> Close </button>
								<button type="button" className="submit-button w-50 m-0 rounded btn-danger" onClick={(e) => this.handleRemoveUser(e) }> Delete </button>
	                		</div>
						</div>
					</div>
				</React.Fragment>
			)
		} else {
			return;
		}
	}

	renderMessageModal() {
	    const { isShowMessageModal, success_message, error_message } = this.state;

	    if (!isShowMessageModal) return null;
	    return (
	        <div className="motor-modal-overlay">
	            <div className="motor-modal-content text-center">
	                {(success_message === '' && error_message === '') ? (
	                    <GearSpinner />
	                ) : (
	                    <>
	                        {success_message && (
	                            <>
	                                <h4 className="alert-heading fw-bold" style={{ color: '#0f5132' }}>Success!</h4>
	                                <p style={{ color: '#0f5132' }}>{success_message}</p>
	                            </>
	                        )}
	                        {error_message && (
	                            <>
	                                <h4 className="alert-heading fw-bold" style={{ color: '#842029' }}>Error!</h4>
	                                <p style={{ color: '#842029' }}>{error_message}</p>
	                            </>
	                        )}
	                    </>
	                )}
	            </div>
	        </div>
	    );
	}

	confirmDelete(e, memberId) {
		e.preventDefault();
		this.setState( {isShowConfirmationModal : true, deleteMemberId : memberId });
	}

	renderUserData(userData) {
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-6 col-sm-6 col-lg-6 col-xl-8 col-4">
						<div className="mb-3">
							<div className="admin-upload-logo">
								<img src={userData.company_logo} className="img-fluid d-block" alt="Upload Logo"/>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-sm-6 col-lg-6 col-xl-4 col-8">
						<h6 className="dark-color1 text-center">{`${userData.company}${userData.address ? `, ${userData.address}` : ''}${userData.city ? `, ${userData.city}` : ''}${userData.state ? `, ${userData.state}` : ''}${userData.zip ? `, ${userData.zip}` : ''}`}
						</h6>
						<div className="address-details-div my-3">
							<h6 className="dark-color1 text-center">My Techtop Sales Representative: </h6>
							<ul>
								<li><img src={teamUserIcon} className="img-fluid d-block" alt=""/> {`${userData.first_name} ${userData.last_name}`}</li>
								<li><img src={teamMailIcon} className="img-fluid d-block" alt=""/> <a href={`mailto:${userData.email}`}>{userData.email}</a></li>
								<li><img src={teamPhoneIcon} className="img-fluid d-block" alt=""/> <a href={`tel:${userData.phone}`}>{userData.phone}</a></li>
							</ul>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderTeamMember() {
		const { team_members, user_roles, isSpin, fields, errors } = this.state;
		return(
			<React.Fragment>
				<table className="table text-center table-bordered" id="techtop-team-members-form">
					<thead>
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>Email</th>
							<th>Pricing</th>
							<th>Order History</th>
							<th>Open orders</th>
							<th>Role</th>
							<th>Status</th>
							<th style={{ width: "100px" }}></th>
							<th style={{ width: "55px" }}></th>
						</tr>
					</thead>
					<tbody>
					{isSpin ? 
						(
							<tr>
								<td colSpan="10"><GearSpinner /></td>
							</tr>
						) :
						(
							<React.Fragment>
								{(team_members.length > 0) && (
									team_members.map((member, index) => (
										<React.Fragment key={index}>
											<tr>
												<td><p>{member.first_name}</p></td>
												<td><p>{member.last_name}</p></td>
												<td><p>{member.email}</p></td>
												<td onClick={() => this.setTeamAccess('is_show_net_pricing', `${member.id}`)} style={{cursor : 'pointer'}}>
													{member.is_show_net_pricing ? (
														<img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
														)
														: null
													}
												</td>
												<td onClick={() => this.setTeamAccess('is_show_order_history', `${member.id}`)} style={{cursor : 'pointer'}}>
													{member.is_show_order_history ? (
														<img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
														)
														: null
													}
												</td>
												<td onClick={() => this.setTeamAccess('is_show_open_order', `${member.id}`)} style={{cursor : 'pointer'}}>
													{member.is_show_open_order ? (
														<img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
														)
														: null
													}
												</td>
												<td>
													<select className="form-select" defaultValue={member.user_role} onChange={this.handleRoleChange.bind(this,`${member.id}`)}>
														<option value="">Select</option>
														{Object.entries(this.state.user_roles).map(([key, value]) => (
										                    <option key={key} value={key}>
										                        {value}
										                    </option>
										                ))}
													</select>
												</td>
												<td><p>{(member.status === 'approved') ? <strong>{ucwords(member.status)}</strong> : ucwords(member.status)}</p></td>
												<td>
				                                    {member.status === "pending" ? (
				                                        <a href="#" onClick={(e) => this.reSendInvitation(e ,member.id)}>Resend Invite</a>
				                                    ) : (
				                                        <a onClick={(e) => this.confirmDelete(e ,member.id)} href="#">Remove</a>
				                                    )}
				                                </td>
												<td>
													{member.status !== 'approved' && (
														<a onClick={(e) => this.confirmDelete(e ,member.id)} href="#">
															<img src={teamDeleteIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "25px" }} />
														</a>
													)}
												</td>
											</tr>
										</React.Fragment>
									))
								)}
								<tr>
									<td>
										<input type="text" className="form-control" name="first_name" id="first_name" onChange={this.handleChange.bind(this, "first_name")} value={fields["first_name"]}/>
										{errors.first_name && <div className="text-danger">{errors.first_name}</div>}
									</td>
									<td>
										<input type="text" className="form-control" name="last_name" id="last_name" onChange={this.handleChange.bind(this, "last_name")} value={fields["last_name"]}/>
										{errors.last_name && <div className="text-danger">{errors.last_name}</div>}
									</td>
									<td>
										<input type="email" className="form-control" name="email" id="email" onChange={this.handleChange.bind(this, "email")} value={fields["email"]}/>
										{errors.email && <div className="text-danger">{errors.email}</div>}
									</td>
									<td onClick={() => this.setAccess('is_show_net_pricing')} style={{cursor : 'pointer'}}>
									    {fields.is_show_net_pricing === '1' ? (
									        <img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
									    ) : null}
									</td>
									<td onClick={() => this.setAccess('is_show_order_history')} style={{cursor : 'pointer'}}>
										{fields.is_show_order_history === '1' ? (
											<img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
											)
											: null
										}
									</td>
									<td onClick={() => this.setAccess('is_show_open_order')} style={{cursor : 'pointer'}}>
										{fields.is_show_open_order === '1' ? (
											<img src={teamCheckIcon} className="img-fluid d-block mx-auto" alt="" style={{ width: "20px" }} />
											)
											: null
										}
									</td>
									<td>
										<select className="form-select" name="user_role" id="user_role" onChange={this.handleChange.bind(this, "user_role")}>
											<option value="">Select</option>
											{Object.entries(this.state.user_roles).map(([key, value]) => (
							                    <option key={key} value={key}>
							                        {value}
							                    </option>
							                ))}
										</select>
										{errors.user_role && <div className="text-danger">{errors.user_role}</div>}
									</td>
									<td></td>
									<td>
										<button type="button" className="red-btn" onClick={(e) => this.handleInvite(e)}>Invite</button>
									</td>
									<td></td>
								</tr>
							</React.Fragment>
						)
					}
					</tbody>
				</table>
			</React.Fragment>
		)
	}

	renderFormError() {
		const { form_error_message } = this.state;
		return(
			<React.Fragment>
				{(form_error_message) && 
					(
						<React.Fragment>
							<div className="alert alert-danger text-center mt-2" role="alert">
								<h4 className="alert-heading fw-bold"> Error !</h4>
								<p>{ form_error_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderFormSuccess() {
		const { form_success_message } = this.state;
		return(
			<React.Fragment>
				{(form_success_message) && 
					(
						<React.Fragment>
							<div className="alert alert-success text-center mt-2" role="alert">
								<h4 className="alert-heading fw-bold"> Success !</h4>
								<p> { form_success_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderUnauthorisedView() {
		return(
			<React.Fragment>
				<div className="motor-modal-overlay">
					<div className="motor-modal-content">
						<div className="alert alert-danger text-center mt-2" role="alert">
							<h4 className="alert-heading fw-bold">Sorry ! you are not authorized to view this page.</h4>
						</div>
						<div className="d-flex w-100 justify-content-evenly gap-4">
							<a href="/user/my-account" className="btn2">My Account</a>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderAuthorisedView() {
		const { page, userData, isLoading } = this.state;
		return(
			<React.Fragment>
				<Loader isLoading={isLoading} message="Processing..."/>
				<div className="techtop-default-title2">
					<div className="row">
						<div className="col-6">	
							<h1 className="m-0 dark-color1">Team Details</h1>
						</div>
						<div className="col-6">	
							<h2 className="m-0 dark-color1 text-end">{userData.company}</h2>
						</div>
					</div>
				</div>
				<div id="ip-my-account-form"> 
					<div className="row">
						<div className="col-md-3">	
							<SideBar page={page}/>
						</div>
					 
						<div className="col-md-9">	
							<form className="form py-3">
								{this.renderUserData(userData)}	
								<div className="row">
									<div className="col-md-12 mt-3">
										<h4>TEAM MEMBERS</h4>
										<div className="table-responsive">
											{this.renderTeamMember()}
										</div>	
									</div>
								</div>	
							</form>
						</div>	
					</div>		
				</div>
			</React.Fragment>
		)
	}

	render() {
		const { userData } = this.state;
		const isAssociate = userData.user_role === 'associate';
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					{this.renderConfirmationModal()}
					{this.renderMessageModal()}
					<section className="techtop-team-details-section pb-5">	
						<div className="container">
							{this.renderFormError()}
							{this.renderFormSuccess()}
							<div className="row">
								<div className="col-md-12">
								{
									(isAssociate ?
										this.renderUnauthorisedView() :
										this.renderAuthorisedView()
									)
								}
								</div>
							</div>
						</div>
					</section>

				</main>	
			</React.Fragment>
		)
	}
}

export default TeamDetails;